import React from "react";
import _ from "underscore";
import { hideDialog, showDialog } from "../../../actions/dialog";
import { updatePriorities } from "../../../actions/priority";
import { Permission } from "../../../api/session";
import M from "../../../strings";
import PriorityControl from "../../components/priorityControl";
import AbstractEntitiesGrid from "./abstractEntitiesGrid";
import { alert } from "../../../plugins";
import { setActiveMenuItem } from "../../../actions/menu";
import { secureScreen } from "../../components/secure";

class QuestionTemlpatesGrid extends AbstractEntitiesGrid {

    constructor(props) {
        super(props);

        this.state.sortDialogHidden = true;
        this.state.category = null;
    }

    componentDidMount() {
        super.componentDidMount();
        setActiveMenuItem({id: this.getEntity()})
    }

    getInitialQuery() {
        const query = super.getInitialQuery();
        query.sort("categoryId", false);
        query.sort("priority", false);

        return query;
    }

    getActions() {
        const actions = super.getActions();

        actions.push({
            id: "sorting",
            type: "icon",
            icon: "zmdi zmdi-sort",
            tooltip: M("sorting"),
            permissions: [this.getEntity() + ":" + Permission.EDIT],
            action: () => { 
                const selection = _.first(this.getSelection());
                if (!_.isEmpty(selection)) {
                    showDialog({
                        title: `${M("sorting")} ${M("questions")} ${M("category")} ${selection.category?.description ?? M("category")}`,
                        getContent: () => (<PriorityControl
                                    entity="questionTemplate"
                                    parent={selection.category?.id}
                                />),
                        buttons: {
                            left: [
                                {
                                    text: M("close"),
                                    action: () => hideDialog(),
                                },
                            ],
                            right: [
                                {
                                    text: M("save"),
                                    action: () => {
                                            updatePriorities({
                                                entity: this.getEntity(),
                                            }).finally(hideDialog);
                                        },
                                },
                            ],
                        },
                    })
                }else{                    
                    alert(M("ooops"), M("selectAQuestion"));
                }
            }
        });

        return actions;
    }

}

export default secureScreen(QuestionTemlpatesGrid)